module.exports = __webpack_public_path__ + "static/media/whatsapp-call.2660249a.svg";